<template>
  <p
    class="value-proposition-container"
    :style="{ background, color }"
  >
    {{ value }}
  </p>
</template>

<script>
import { hexToRgba } from '@/helpers/colors';

export default {
  name: 'HomeTabValueProposition',
  props: {
    value: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      background: '',
    };
  },
  watch: {
    color: {
      immediate: true,
      async handler() {
        this.background = await hexToRgba(this.color, 0.05);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.value-proposition-container {
  padding: 10px 13px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  font-weight: 300;
  color: @text-darkest;
}
</style>
